module.exports = __webpack_public_path__ + "static/media/turn-on-icon.5de81cf8.png";